import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38c7bdd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home__couple",
  id: "product"
}
const _hoisted_2 = { class: "couple__text-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "couple__media-wrapper" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#follow",
  class: "couple__link"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "54",
    height: "68",
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      opacity: "0.34",
      d: "M43.7435 53.9981C34.7272 66.293 24.618 68.0007 20.8612 68.0007C10.0089 68.0007 3.69175 55.579 3.44345 46.1432C-0.313245 46.1432 -0.777722 32.6088 3.44345 31.4576C-0.996261 6.52622 32.1317 -11.2334 44.4265 10.9659C58.429 12.332 53.6477 32.482 49.8909 39.654C55.7137 39.654 49.6318 57.5311 43.7435 53.9981Z",
      class: "svgavatar",
      fill: "#111"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M35.5619 39.657H28.3899V47.2133H25.2308V39.657H18.0801V36.69H25.2308V29.1338H28.3899V36.69H35.5619V39.657Z",
      fill: "white"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        innerHTML: _ctx.t('Home.couple.title')
      }, null, 8, _hoisted_3),
      _createElementVNode("span", {
        innerHTML: _ctx.t('Home.couple.additional')
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("img", {
        src: require('@/assets/cards/couple.png'),
        alt: "Найти знакомства по интересам"
      }, null, 8, _hoisted_6),
      _hoisted_7
    ])
  ]))
}